<script>
import VLeaseAttachmentsModal from "./VLeaseAttachmentsModal.vue";

export default {
    components: { VLeaseAttachmentsModal },
    props: {
        land_lease: { type: Object, required: true }
    },
    data() {
        return {
            showAttachmentsModal: false,
            openAddForm: false
        };
    },
    methods: {
        openModal(withAddForm) {
            this.openAddForm = !!withAddForm;
            this.showAttachmentsModal = true;
        },
        closeModal() {
            this.showAttachmentsModal = false;
            this.openAddForm = false;
        }
    },
    computed: {
        attachments() {
            return this.land_lease.land_lease_attachments || [];
        },
        hasAttachments() {
            return this.attachments.length >= 1;
        }
    }
};
</script>

<template>
    <div>
        <h4>{{ $t("land_leases.contract_and_attachments") }}</h4>
        <div>
            <a
                v-if="land_lease.contract_url"
                :href="land_lease.contract_url"
                target="_blank"
            >
                <i class="far fa-file-contract fa-fw"></i>
                {{ $t("land_leases.contract") }}
            </a>
            <span v-else class="text-muted">
                <i class="far fa-file-contract fa-fw"></i>
                {{ $t("land_leases.no_contract_specified") }}
            </span>
        </div>
        <div class="mt-2">
            <span
                class="text-primary m-click"
                :class="{ 'cursor-pointer': hasAttachments }"
                @click="hasAttachments && openModal(false)"
            >
                <i class="far fa-folder-open fa-fw"></i>
                {{ $t("land_leases.attachments") }}
            </span>
            <div class="small text-muted ml-4">
                {{ $tc("land_lease.X_files", attachments.length) }}
            </div>
        </div>
        <div class="mt-2">
            <base-button
                size="sm"
                outline
                type="primary"
                @click="openModal(true)"
            >
                <i class="far fa-plus"></i>
                {{ $t("land_leases.add_attachment") }}
            </base-button>
        </div>

        <portal to="modals">
            <v-lease-attachments-modal
                v-if="showAttachmentsModal"
                :land-lease="land_lease"
                :init-add-form="openAddForm"
                @close="closeModal"
            />
        </portal>
    </div>
</template>
